import React from "react"
import styled from "styled-components"
import { sendGAEvent } from "gatsby-plugin-analytics"

const Container = styled.div`
  margin-top: 2em !important;
  text-align: center;

  a {
    background: #336633;
    color: #ffffff !important;
    display: inline-block;
    max-width: 100%;
    padding: 1.5em 2em;
    text-align: center;
    text-decoration: none !important;
    width: max-content;

    &:active,
    &:focus,
    &:hover {
      background: #558855;
      color: #ffffff;
      text-decoration: none;
    }

    &::after {
      content: " \\2192";
      margin-left: 5px;
    }
  }
`

const CTAButton = ({ text, link, children }) => {
  return (
    <Container>
      <a
        href={link}
        target="_blank"
        rel="nofollow"
        onClick={() => {
          sendGAEvent({
            event: "Redirect",
          })
        }}
      >
        {text ? text : children}
      </a>
    </Container>
  )
}

export default CTAButton
